import { FiMapPin } from "react-icons/fi";
import "../../styles/fieldMap.css";

export default function LocationPermissionModal({
  open,
  onAllow,
  onDismiss,
  busy = false,
  error = "",
  description,
  allowLabel = "Allow location",
  mandatory = false,
  title = "Turn on your location",
}) {
  if (!open) return null;

  const bodyText =
    description ||
    "Allow location access so the Field map can show your live position while you are logged in.";

  return (
    <div className="field-map-permission-backdrop" role="presentation">
      <div
        className="field-map-permission-dialog"
        role="dialog"
        aria-labelledby="field-map-permission-title"
        aria-modal="true"
      >
        {!mandatory && onDismiss ? (
          <button
            type="button"
            className="field-map-permission-close"
            onClick={onDismiss}
            aria-label="Close"
          >
            ×
          </button>
        ) : null}
        <div className="field-map-permission-icon" aria-hidden>
          <FiMapPin />
        </div>
        <h2 id="field-map-permission-title">{title}</h2>
        <p>{bodyText}</p>
        {error ? <p className="field-map-permission-error">{error}</p> : null}
        <div className="field-map-permission-actions">
          <button
            type="button"
            className="primary-page-btn"
            onClick={onAllow}
            disabled={busy}
          >
            {busy ? "Getting location…" : allowLabel}
          </button>
          {!mandatory && onDismiss ? (
            <button type="button" className="secondary-page-btn" onClick={onDismiss}>
              Not now
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
